<template>
    <v-progress-circular :size="size" :width="width" :color="color" :indeterminate="indeterminate" />
</template>

<script>
export default {
    name: 'AppProgress',
    props: {
        size: {
            type: Number,
            default: 16
        },
        width: {
            type: Number,
            default: 2
        },
        color: {
            type: String,
            default: 'primaryBackground'
        },
        indeterminate: {
            type: Boolean,
            default: false
        }
    }
};
</script>
